export async function readImageDimensions(
  file: File,
): Promise<{ width?: number; height?: number }> {
  return new Promise((resolve) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      resolve({
        width: image.naturalWidth,
        height: image.naturalHeight,
      });
      URL.revokeObjectURL(objectUrl);
    };

    image.onerror = () => {
      resolve({});
      URL.revokeObjectURL(objectUrl);
    };

    image.src = objectUrl;
  });
}
